import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';
import FeedbackDialogListener from '@components/Modal/Content/FeedbackModalContent/FormDialog';

import { VITALL_ABOUT, VITALL_HELP } from '@constants/external-links';

import { FeedbackEmailType } from 'generated/types';

import {
  Footer,
  FooterItem,
  IconWrapper,
  InnerFooter,
} from './DashFooter.style';

const messages = defineMessages({
  feedback: {
    id: 'dashFooter.feedback',
    defaultMessage: 'Feedback',
  },
  about: {
    id: 'dashFooter.about',
    defaultMessage: 'About',
  },
  help: {
    id: 'dashFooter.help',
    defaultMessage: 'Help',
  },
});

function DashFooter() {
  const { formatMessage } = useIntl();

  return (
    <Footer>
      <InnerFooter>
        <FeedbackDialogListener type={FeedbackEmailType.Client_Feedback}>
          {({ handleOpen }) => (
            <FooterItem onClick={handleOpen}>
              <IconWrapper>
                <Icon clickable color="grey.A700" name="comment-dots" />
              </IconWrapper>
              {formatMessage(messages.feedback)}
            </FooterItem>
          )}
        </FeedbackDialogListener>

        <FooterItem onClick={() => window.open(VITALL_ABOUT, '_blank')}>
          <IconWrapper>
            <Icon clickable color="grey.A700" name="circle-info" />
          </IconWrapper>
          {formatMessage(messages.about)}
        </FooterItem>
        <FooterItem onClick={() => window.open(VITALL_HELP, '_blank')}>
          <IconWrapper>
            <Icon clickable color="grey.A700" name="comment-question" />
          </IconWrapper>
          {formatMessage(messages.help)}
        </FooterItem>
      </InnerFooter>
    </Footer>
  );
}

export default DashFooter;
